var React = require('react');

function MenuOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 7.5A1.5 1.5 0 0 1 5.5 6h21a1.5 1.5 0 0 1 0 3h-21A1.5 1.5 0 0 1 4 7.5zm0 9A1.5 1.5 0 0 1 5.5 15h21a1.5 1.5 0 0 1 0 3h-21A1.5 1.5 0 0 1 4 16.5zM5.5 24a1.5 1.5 0 0 0 0 3h21a1.5 1.5 0 0 0 0-3h-21z","fill":"#fff"}));
}

MenuOpen.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = MenuOpen;

MenuOpen.default = MenuOpen;
